module.exports = __webpack_public_path__ + "img/illustration-tnoir.01a886db.png";